import { Injectable } from '@angular/core';
import { ServicePlus, TYPE } from '../models/ServicePlus';
import { ADN_PLUS } from "../models/ADN_PLUS";
import { Condition } from "../models/Condition";
import { OperationException } from '../models/OperationException';
import { eConcatOption, eOperator, OperationParam } from '../models/OperationParam';
import { EntityField } from '../models/EntityField';
import { Store } from '@ngrx/store';
import { Action, AppState, UtilParam } from '../models';
import { CtFormComponent, CtrlBaseComponent } from '../controls';
import { IBaseController } from '../interfaces';
import * as moment from 'moment';
import { PfComponents } from '../enums/pfComponents';
import { StoreService } from './store.service';
import { defaultIfEmpty, take } from 'rxjs/operators';

//declare var $: any;

@Injectable()
export class UtilService {

  currentViewId: string;
  currentView: IBaseController;
  //viewStack = [];

  constructor(private appStore: Store<AppState>, private storeService : StoreService) {
    this.appStore.select(store => store).subscribe((state: any) => {
      this.currentView = state.currentView;
    });
  }

  getComponentRef(component: string): any {
    if (!component) return
    let compRef;
    component = this.getParsedId(component);
    if (('CT_' + component) == this.currentView.getId()) {
      compRef = this.currentView;
    } else
      compRef = this.currentView.getRoot().getChildById(component, true);

    return compRef;
  }

  getParsedId(component) {
    let vViewRegex = new RegExp('^.{2}\\_VI[0-9]{1,5}');
    if (!vViewRegex.test(component)) {
      component = this.currentViewId + "_" + component;
    }
    return component;
  }

  getStringAttribute(name: string, attributes: any): any {
    if (attributes) {
      for (let att of attributes) {
        if (att.Name == null) att.Name = "";
        if (att.Alias == null) att.Alias = "";
        if (att.Name === name || att.Alias === name)
          return String(att.Value);
      }
    }
    return null;
  }

  getAdnFromList(adnList: any, name: any, value: any): any {
    for (let adn of adnList) {
      if (this.getSelectedAdn(name, value, adn.ArrayEntities.List))
        return adn;
    }
    return null;
  }

  getSelectedAdn(name: string, value: any, attributes: any): any {
    for (let att of attributes) {
      if (att.Name == null) att.Name = "";
      if (att.Alias == null) att.Alias = "";
      if (att.Value === value)
        return true
    }
    return null;
  }

  setParameterValue(name: string, attributes: any, value: any) {
    for (let att of attributes) {
      if (att.Name == null) att.Name = "";
      if (att.Alias == null) att.Alias = "";
      if (att.Name === name || att.Alias === name)
        att.Value = value;
    }
    return null;
  }

  convertAdnToSelectOptions(adns: any, fieldValue: any, fieldText: any): any {

    if (!adns)
      return;

    let options: any = [];

    for (let listItem of adns) {
      let listItemValue;
      let listItemDescription;
      if (fieldValue && fieldText) {
        listItemValue = this.getStringAttribute(fieldValue, listItem.ArrayEntities.List);
        listItemDescription = this.getStringAttribute(fieldText, listItem.ArrayEntities.List);
      } else {
        listItemValue = this.getStringAttribute("LIST_VALUE", listItem.ArrayEntities.List);
        listItemDescription = this.getStringAttribute("DESCRIPTION", listItem.ArrayEntities.List);
      }
      options.push({ text: listItemDescription, value: (listItemValue == 'null' ? null : listItemValue) })
    }
    return options;
  }

  BuildServicePlus(entity: string, operationName: string, type: any, event, response: any = null, pViewId: string): ServicePlus {
    let serv = new ServicePlus(entity, operationName, type);
    let componentsMap = {};
    if (event) {
      serv.Params = event.params;
      if (event.actionParams && event.actionParams.length > 0) {
        let adn = new ADN_PLUS();
        serv.Data.push(adn);
        this.AddFieldsToServicePlus(serv.Data[0].ArrayEntities, event.actionParams, false, serv, componentsMap, true, pViewId);
        if (response !== null && response.length > 0)
          this.AddFieldsToServicePlus(serv.Data[0].ArrayEntities, response, true, serv, componentsMap, true, pViewId);
      }
      if (event.conditionParams && event.conditionParams.length > 0) {
        serv.Conditions = new Condition();
        this.AddFieldsToServicePlus(serv.Conditions, event.conditionParams, false, serv, componentsMap, false, pViewId);
      }
    }
    if (response !== null) {
      serv.Params = response.params ? response.params : serv.Params;
      this.addLocalData(serv, response, pViewId)
    }

    if (event.confirmField && event.confirmValue) {
      serv.Conditions.addConditionField(event.confirmField, event.confirmValue);

      if (serv.Data && serv.Data.length > 0)
        serv.Data[0].addAttribute(event.confirmField, event.confirmValue);
    }
    return serv;
  }

  private addLocalData(serv, localData, pViewId) {
    if (localData.actionParams && localData.actionParams.length > 0) {
      let adn = new ADN_PLUS();
      (!serv.Data[0]) ? serv.Data.push(adn) : null;
      this.AddFieldsToServicePlus(serv.Data[0].ArrayEntities, localData.actionParams, true, serv, {}, true, pViewId);
    }
    if (localData.conditionParams && localData.conditionParams.length > 0) {
      (!serv.Conditions) ? serv.Conditions = new Condition() : null;
      this.AddFieldsToServicePlus(serv.Conditions, localData.conditionParams, true, serv, {}, false, pViewId);
    }
  }

  private AddFieldsToServicePlus(arrayEntities, componentsIds, isLocal, serv, componentsMap = null, isData = false, pViewId: string) {
    for (let componentId of componentsIds) {
      if (isLocal)
        arrayEntities.addEntityField({ Name: componentId.modelId, Value: componentId.value });
      else {
        let componentRef = this.getComponentRef(componentId);
        if (componentRef) {
          {
            let attName = (componentRef.getCtType() !== 'CtForm') ? componentRef.getModelId() : 'FORM';
            if (attName && attName !== "")
              componentsMap[attName] = componentId;
            if (componentRef.getCtType() !== "CtInputFile") {
              if (componentRef.getCtType() === 'CtTable' && componentRef.getMultipleSelection() && componentRef.getSelectedAdns() && isData) {
                let tableSelecteds = componentRef.getSelectedAdns();
                serv.Data = tableSelecteds;
              } else {
                this.addEntityField(arrayEntities, componentRef, serv);
              }
            } else
              if (componentRef.getProcessedFiles())
                serv.Files = [...componentRef.getProcessedFiles()];
              else if (componentRef.required)
                throw new OperationException('No hay archivos seleccionados.', new OperationException('RF-0202'));
          }
        }
        if (serv.Params) {
          for (var p of serv.Params) {
            if (this.findFieldOnComponent(componentRef, p.Field.replace("C_", "")) && Object.keys(p.componentsMap).length == 0) {
              let attName = (componentRef.getCtType() !== 'CtForm') ? componentRef.getModelId() : 'FORM';
              if (attName && attName !== "") {
                p.componentsMap[attName] = componentId;
              }
            }
          }
        }
      }
    }
  }

  private addEntityField(arrayEntities, component, serv) {
    if (component.getCtType() === 'CtTable' || component.getCtType() === 'CtDataTable'
      || component.getCtType() === 'CtForm' || component.getCtType() === 'CtEmailForm'
      || component.getCtType() === 'CtFilterWindow') {
      let list = [];
      if (component.getCtType() === 'CtTable' || component.getCtType() === 'CtDataTable') {

        if (component.getSelectedAdn()) {
          list = component.getSelectedAdn() ? component.getSelectedAdn().ArrayEntities.List : [];
        }

      } else if (component.getCtType() === 'CtForm') {
        component.updateFormElements();
        list = component.getBindingAdn() ? component.getBindingAdn().ArrayEntities.List : [];
      } else if (component.getCtType() === 'CtEmailForm') {
        list = new ADN_PLUS(component.getADNRecipientsList()).ArrayEntities.List || [];
      } else if (component.getCtType() === 'CtFilterWindow') {
        if (component.getSelectedAdns()) {
          component.getSelectedAdns().forEach((ent) => {
            ent.ArrayEntities.List.forEach((listValue: EntityField) => {
              if (listValue.Value === 'N') listValue.Value = null;
              list.push(listValue);
            })
          })
        }
      }
      for (let entity of list)
        arrayEntities.addEntityField(entity);
    } else if (component.getCtType() === 'CtChart') {
      arrayEntities.addEntityField({ Name: component.getFieldCriteria(), Value: component.getValue(), type: 1 });
    } else if (component.getCtType() === 'CtMessage') {
      const adn: ADN_PLUS = component.getValue();
      for (let entity of adn.ArrayEntities.List) {
        arrayEntities.addEntityField(entity);
      }
    } else {
      arrayEntities.addEntityField({ Name: component.getModelId(), Value: component.getValue(), type: component.getInputDataType() });
    }
  }

  parseDbDateToUiDate(date) {
    if (date) {
      let newDate = (date === '') ? '' : date.split('/');
      if (newDate !== '' && newDate.length < 4)
        var a = moment(date, "YYYYMMDD");
      else
        return date;
      return a.format('DD/MM/YYYY');
    }
    return "";
  }

  parseUiDateToDbDate(date) {
    if (date)
      return moment(date, 'DD/MM/YYYY').format('YYYYMMDDhhmmss');
    return "";
  }

  parseDate(date, format, newformat) {
    if (date)
      return moment(date, format).format(newformat);
    return null;
  }

  isNullOrWhiteSpace(text: string) {
    return !text || !text.trim();
  }

  deepClone(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;

    // Handle Date
    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
      copy = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.deepClone(obj[i]);
      }
      return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
      copy = {};
      for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = this.deepClone(obj[attr]);
      }
      return copy;
    }

    throw new OperationException("Unable to copy obj! Its type isn't supported.", new OperationException("RF-0201"));

    //var copy = $.extend(true, {}, obj);
    //return copy;
  }

  checkDefaultParams(serv: ServicePlus) {
    for (let param of serv.Params) {
      let containsField = false;
      let fieldValue = null;

      if (param.IsConditionParam()) {
        containsField = serv.Conditions ? serv.Conditions.hasCondition(param.GetRawName()) : false;
        fieldValue = serv.getCondition(param.GetRawName());
      } else {
        containsField = serv.Data ? (serv.Data.find(x => x.ContainsAttribute(param.Field)) ? true : false) : false;
        fieldValue = serv.getDataElement(param.GetRawName());
      }
      if (!containsField || (fieldValue == null && param.DefaultValue != 'null')) {
        if (this.isNullOrWhiteSpace(param.DefaultValue))
          throw new OperationException(`El valor del campo ${param.DisplayName || param.Field.replace("C_", "")} no puede ser nulo o indefinido`, new OperationException("RF-0200"));

        if (param.IsConditionParam()) {
          if (serv.Conditions === null)
            serv.Conditions = new Condition();

          serv.Conditions.addConditionField(param.GetRawName(), param.GetDefaultValue());
        }
        else {
          if (serv.Data === null)
            serv.Data = new Array<ADN_PLUS>()

          for (let adn of serv.Data) {
            containsField = adn.ContainsAttribute(param.Field);

            if (!containsField)
              adn.addAttribute(param.Field, param.GetDefaultValue());
            else
              adn.setStringAttribute(param.Field, param.GetDefaultValue());
          }
        }
      }
    }

  }

  getEventUtilParam(event, key, type): any {
    if (!event) return;
    if (!event.utilParams) return
    for (let set of event.utilParams) {
      if (set.dataSource === type) {
        let field = set.name.split('=')[0];
        if (field === key)
          return set.name.split('=')[1];
      }
    }
  }

  getByteArray(data: any) {
    let nData = data.Data ? data.Data : data;
    var byteCharacters = atob(nData);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    return new Uint8Array(byteNumbers);
  }

  getBinaryUrl(data, type) {
    var pdfAsArray = this.getByteArray(data);
    var binaryData = [];
    binaryData.push(pdfAsArray);
    var dataPdf = window.URL.createObjectURL(new Blob(binaryData, { type: type }));
    return dataPdf;
  }

  downloadPlusReport(report: any, blob: any) {
    if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
      window.navigator.msSaveOrOpenBlob(blob, report.Name + (report.Format.startsWith('.') ? '' : '.') + report.Format);
    }
    else {
      let fileName = report.Name + (report.Format.startsWith('.') ? '' : '.') + report.Format
      this.createAdownloadATag(blob, fileName)
    }
  }

  createAdownloadATag(blob, fileName?) {
    if (window.navigator.msSaveBlob) { // // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
    else {
      var a = window.document.createElement("a");
      a.setAttribute("download", "");
      a.href = window.URL.createObjectURL(blob);

      a.download = fileName;
      document.body.appendChild(a);
      a.click();  // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
      document.body.removeChild(a);
    }
  }

  findFieldOnComponent(component, fieldToFind) {
    if (!component) return
    let adn: ADN_PLUS = null;
    switch (component.getCtType()) {
      case 'CtForm':
        adn = new ADN_PLUS(component.getBindingAdn());
        return adn ? adn.ContainsAttribute(fieldToFind) : null;
      case 'CtDataTable':
      case 'CtTable':
        adn = new ADN_PLUS(component.getSelectedAdn());
        return adn ? adn.ContainsAttribute(fieldToFind) : null;
      case 'CtChart':
        return (fieldToFind == component.getFieldCriteria());
      default:
        return (fieldToFind == component.getModelId());
    }
  }

  getAdnFromAnyComponent(component): ADN_PLUS {
    let componentRef = this.getComponentRef(component);
    if (!componentRef) return
    let adn;
    switch (componentRef.getCtType()) {
      case 'CtForm':
        return new ADN_PLUS(componentRef.getBindingAdn());
      case 'CtDataTable':
      case 'CtTable':
        return new ADN_PLUS(componentRef.getSelectedAdn())
      case 'CtInputText':
      case 'CtInputDate':
      case 'CtInputNumber':
      case 'CtInputCheckbox':
      case 'CtInputRadio':
        adn = new ADN_PLUS();
        adn.ArrayEntities.addEntityField({ Name: componentRef.getModelId(), Value: componentRef.getValue(), type: componentRef.getInputDataType() });
        return adn;
      case 'CtChart':
        adn = new ADN_PLUS();
        adn.ArrayEntities.addEntityField({ Name: componentRef.getFieldCriteria(), Value: componentRef.getValue(), type: 1 });
        return adn;
      case 'CtEmailForm':
        return new ADN_PLUS(componentRef.getADNRecipientsList());
      case 'CtFormList':
        return new ADN_PLUS(componentRef.getSelectedFormBindingAdn());
      default:
        return new ADN_PLUS();
    }
  }

  setAdnToAnyComponent(componentRef, response, event?) {

    let component;
      component = this.getComponentRef(componentRef);

      if(component !== null && component !== undefined){
    switch (component.getCtType()) {
      case 'CtList':
        component.setItems(response);
        break;
      case 'CtTable':
        if ((!component.tableData || component.tableData.length === 0) && (!response || response.length === 0))
          break;

        component.setDynamicProperties(component, 'tableData', response);

        let vSelectRow = this.getEventUtilParam(event, 'cSelectRow', 'constant');

        component.updateTable(vSelectRow, true);
        break;
      case 'CtDataTable':
        component.setDynamicProperties(component, 'tableData', response);
        component.updateTable();
        break;
      case 'CtForm':
        (<CtFormComponent>component).updateBindingAdn(response);
        //component.setDynamicProperties(component, "bindingAdn", response);
        //component.bindAdnToForm();
        break;
      case 'CtSelect':
        if (response && response instanceof Object)
          this.setDataFromAdn(response, component);
        else
          component.setValue(response);
        component.formControl.reset([response]);
        break;
      case 'CtChart':
        component.setAdnList([...response]);
        component.filterAndConvertData();
        break;
      case 'CtBarFilter':
        component.setAndSearch(response);
        break;
      case 'CtEmailForm':
        if (response && response instanceof Array)
          component.bindAdnToRecipients(response[0]);
        else
          component.bindAdnToRecipients(response);
        break;
      case 'CtFormList':
        if (response && response instanceof Array) {
          component.setAdnList(response);
          component.paintForms()
        } else {
          component.setAdnList([response]);
          component.paintForms()
        }
        break;
      case 'CtTimeline':
        if (response && response instanceof Array) {
          component.setAdnList(response);
          component.convertAnListToTimelineItem()
        } else {
          component.setAdnList([response]);
          component.convertAnListToTimelineItem()
        }
        break;  
      case 'CtMessageContainer':
        component.setValue(response);
        break;
      case 'CtButtonUncompressedContainer':
        component.setADN(response);
        break;
      default:
        if (response && response instanceof Object)
          this.setDataFromAdn(response, component);
        else
          component.formControl.reset(response);
        break;
    } 
  }

  }

  setDataFromAdn(adn, component) {
    let arrayEntities = adn.Data ? adn.Data.ArrayEntities : adn.ArrayEntities ? adn.ArrayEntities : (adn instanceof Array && adn.length > 0) ? adn[0].ArrayEntities : [];

    if (!arrayEntities.List)
      return;

    for (let entity of arrayEntities.List) {
      if (component.modelId === entity.Name || component.modelId === entity.Alias) {
        component.setValue(entity.Value);
        //component.formControl._updateValue(entity.Value);
        //component.formControl.reset(entity.Value);
        break;
      }
    }
  }

  /**
  * Validate this ServicePlus instance against its Params, each param has a field that must match with any EntityField 
  * in ServicePlus.Conditions.Data or ServicePlus.Data.ArrayEntities
  * Returns True or False depending on params validation against Conditions or Data, can throw an Exception if fields are missing or validation can't be performed
  **/
  validateServicePlus(serv: ServicePlus, pPositionsToSkip = 0, pGroupToEvaluate = 0) {
    if (serv.Params.length <= 0)
      return true
    let model = { positionsToSkip: pPositionsToSkip, groupToEvaluate: pGroupToEvaluate };
    let vConcatOperators = new Array<eConcatOption>();
    let vParamsEvaluationsResults = new Array<boolean>();

    for (let vPosition = 0; model.positionsToSkip < serv.Params.length; vPosition++) {
      var vCurrentParam = serv.Params[model.positionsToSkip];

      if (vCurrentParam.IgnoreValidate) {
        model.positionsToSkip++;
        continue;
      };

      if (vPosition == 0 || serv.Params[model.positionsToSkip - 1].Group == vCurrentParam.Group) {
        vConcatOperators.push(vCurrentParam.ConcatOperator);
        vParamsEvaluationsResults.push(this.evaluateServiceParams(serv, vCurrentParam));
        model.positionsToSkip++;
      }
      else {
        vParamsEvaluationsResults.push(this.validateServicePlus(serv, pPositionsToSkip, pGroupToEvaluate));
        vConcatOperators.push(serv.Params[model.positionsToSkip - 1].ConcatOperator);
      }
    }

    let vResult = vParamsEvaluationsResults[0];

    for (let vPosition = 0; vPosition < vParamsEvaluationsResults.length - 1; vPosition++) {
      let vConcatOperator = vConcatOperators[vPosition];

      if (vConcatOperator == eConcatOption.AND)
        vResult = (vResult && vParamsEvaluationsResults[vPosition + 1]);

      else if (vConcatOperator == eConcatOption.OR)
        vResult = (vResult || vParamsEvaluationsResults[vPosition + 1]);
    }

    if (model.positionsToSkip >= serv.Params.length)
      this.validateInputs(serv, vResult, vParamsEvaluationsResults);

    return vResult;
  }

  validateInputs(serv, isOperationValid, paramEvaluationResults) {
    if (!isOperationValid) {
      let index = 0;
      for (var param of serv.Params) {
        if (!param.IgnoreValidate) {
          this.paintValidation(param, paramEvaluationResults[index]);
          index++;
        }
      }
    } else {
      for (var param of serv.Params)
        this.removeValidation(param);
    }
  }


  evaluateServiceParams(serv: ServicePlus, param: OperationParam): boolean {
    if (this.isNullOrWhiteSpace(param.Field))
      throw new OperationException("Validation can't be performed: Field name is empty", new OperationException("ERR_OP-0063"));

    var result = false;
    var entityField: EntityField;

    if (param.Field.startsWith("C_")) {
      entityField = serv.Conditions.Data.find(x => (this.isNullOrWhiteSpace(x.Name) ? x.Alias : x.Name) == param.Field.slice(2));

      if (entityField == null)
        throw new OperationException("El campo [" + param.Field.slice(2) + "] no se encuentra en las condiciones.", new OperationException("ERR_OP-0042"));

      if (param.Operator != eOperator.NONE)
        result = this.evalateParamField(param, entityField.Value);
      else
        result = true;
    }
    else {
      result = (serv.Data.length > 0);
      var i = 0;

      while (result && i < serv.Data.length) {
        entityField = serv.Data[i++].ArrayEntities.List.find(x => (this.isNullOrWhiteSpace(x.Name) ? x.Alias : x.Name) == param.Field);

        if (entityField == null)
          throw new OperationException("El campo [" + param.Field + "] no se encuentra en los datos.[" + (i - 1) + "]", new OperationException("ERR_OP-0053"));

        if (param.Operator != eOperator.NONE)
          result = (result && this.evalateParamField(param, entityField.Value));
      }
    }

    return result;
  }


  evalateParamField(param: OperationParam, fieldValue: string): boolean {
    var result = false;

    if (fieldValue === "" && (param.Operator === eOperator.GREATER_THAN || param.Operator === eOperator.LOWER_THAN))
      throw new OperationException(param.Field + ": Numeric validation can't be performed with no numeric CompareValue", new OperationException("OC-0140"));

    switch (param.Operator) {
      case eOperator.EQUALS:
        result = (fieldValue === param.CompareValue);
        break;
      case eOperator.NOT | eOperator.EQUALS:
        result = (fieldValue !== param.CompareValue);
        break;
      case eOperator.LIKE:
        result = (fieldValue !== null && fieldValue.includes(param.CompareValue));
        break;
      case eOperator.NOT | eOperator.LIKE:
        result = (fieldValue !== null && !fieldValue.includes(param.CompareValue));
        break;
      case eOperator.GREATER_THAN:
        result = parseInt(fieldValue) > parseInt(param.CompareValue);
        break;
      case eOperator.GREATER_THAN | eOperator.EQUALS:
        result = parseInt(fieldValue) >= parseInt(param.CompareValue);
        break;
      case eOperator.LOWER_THAN:
        result = parseInt(fieldValue) < parseInt(param.CompareValue);
        break;
      case eOperator.LOWER_THAN | eOperator.EQUALS:
        result = parseInt(fieldValue) <= parseInt(param.CompareValue);
        break;
      default:
        throw new OperationException("Invalid operator for field " + param.Field, new OperationException("OC-0169"));
    }

    return result;
  }

  paintValidation(param: OperationParam, isValid: boolean) {
    let componentRef: any;
    if (param.Field.indexOf('C_') !== -1) {
      let isConditionField = param.Field.slice(0, 2)
      if (isConditionField === "C_")
        componentRef = this.getComponentRef(param.componentsMap[param.Field.replace("C_", "")]);
      else
        componentRef = this.getComponentRef(param.componentsMap[param.Field]);
    }
    else
      componentRef = this.getComponentRef(param.componentsMap[param.Field])

    if (componentRef) {
      if (param.FormRequired && !isValid)
        this.setElementValidation(true, componentRef);
    } else {
      let element;
      componentRef = this.getComponentRef(param.componentsMap['FORM']);
      if (componentRef)
        element = componentRef.getFormElementByModelId(param.Field.replace("C_", ""));
      if (param.FormRequired && element && !isValid)
        this.setElementValidation(true, element);
    }
  }

  removeValidation(param) {
    let componentRef = this.getComponentRef(param.componentsMap[param.Field.replace("C_", "")]);
    if (componentRef)
      if (!componentRef.formControl.valid) {
        this.setElementValidation(false, componentRef);

      }
  }


  setElementValidation(isRequired: boolean, element) {
    element.setRequired(isRequired);

    try {
      if (element.getCtType() !== 'CtInputNumber') {
        element.formControl.valueAccessor.onTouched();
        element.formControl.control.setErrors({ 'incorrect': true });
      }
      else
        element.formControl.valueAccessor._onTouched();
    }
    catch (Error) { }
  }

  /**
  * Extrae la especificacion basica de un componente angular y retorna una copia de su estado actual
  * @param sourceNode componente con estado original
  * @param updateNode componente con estado modificado
  * @returns copia del estado del componente actual usando el original como plantilla
  */
  extractMetadata(sourceNode: any, updateNode: any): any {
    if (!sourceNode && !updateNode)
      return null;

    // genera una referencia nueva de la especificacion original
    let metadata = JSON.parse(JSON.stringify(sourceNode));
    metadata.models = [];

    // copia las propiedades
    if (updateNode.metaData.controlProperties) {
      for (let prop in updateNode.metaData.controlProperties) {
        let propVal;

        try {
          if (prop == 'value')
            continue
          // intenta usar los getters
          propVal = updateNode['get' + prop[0].toUpperCase() + prop.substring(1)]();
        } catch (ex) {
          // si no existen en la definicion del componente, copia el valor directamente
          propVal = updateNode.metaData.controlProperties[prop];
        }

        // si el valor es un objeto o un array genera una nueva referencia
        if (propVal && (propVal instanceof Object || propVal instanceof Array))
          propVal = JSON.parse(JSON.stringify(propVal));

        metadata.controlProperties[prop] = propVal;
      }

      // CASOS ESPECIALES para persistir estado
      switch (updateNode.getCtType()) {
        case 'CtTable':
          metadata.controlProperties['_tableData'] = updateNode.getTableData();
          metadata.controlProperties['_currentPage'] = updateNode.getCurrentPage();
          metadata.controlProperties['_selectedAdn'] = updateNode.getSelectedAdn();
          metadata.controlProperties['_selectedAdns'] = updateNode.getSelectedAdns();
          break;
        case 'CtTab':
          metadata.controlProperties['_selectedTab'] = updateNode.getSelectedTab();
          break;
        case 'CtForm':
          metadata.controlProperties['_bindingAdn'] = updateNode.getBindingAdn();
          break;
      }
    }

    // copia los hijos del componente actual usando la especificacion original como base
    if (sourceNode.models && updateNode.childElements) {
      for (let i = 0; i < sourceNode.models.length && i < updateNode.childElements.length; i++) {
        let child = this.extractMetadata(sourceNode.models[i], updateNode.childElements[i]);

        if (child)
          metadata.models.push(child);
      }
    }

    return metadata;
  }

  /**
   * Obtiene el nodo cachado con la especificacion y navegacion de la vista
   * @param viewId Id de la vista
   * @param viewStack Se recibe el arreglo de vistas ya que ahora no persiste en memoria
   */
  getCachedView(viewId: string, viewStack: Array<any> = []) {
    viewStack = (!viewStack || viewStack.length == 0) ? this.getViewStack() : viewStack;
    let rootNode = null;

    if (viewStack.length > 0)
      rootNode = viewStack.find(x => x.id == viewId && x.node);
    //delete stack;
    return rootNode;
  }

  /**
   * Limpia los breadcrumbs y la pila de vistas
   */
  clearViewStack() {
    this.setViewStack([]);
  }
  /**
   * Busca y guarda el estado actual de la vista, si no existe la mappea en memoria y persiste en sesion
   * @param node CtView
   */
  checkStack(currentViewNode: any) {
    let stack = this.getViewStack() ? this.getViewStack() : [];
    if (currentViewNode) {
      let oldRefNode = this.getCachedView(currentViewNode.id, stack);

      if (oldRefNode) {
        let a = [this.extractMetadata(JSON.parse(oldRefNode.source).models[0], currentViewNode)]
        oldRefNode.node = JSON.stringify({ models: a });
      } else {
        let sourceView = JSON.stringify({ models: [currentViewNode.metaData] });
        stack.push({ id: currentViewNode.id, node: sourceView, source: sourceView });
      }

      //sessionStorage.setItem("viewStack", JSON.stringify(stack));
      this.setViewStack(stack);
    }
  }

  getViewStack(): Array<any> {
    let stack = JSON.parse(sessionStorage.getItem("viewStack")) || [];
    stack = (stack.length > 0) ? stack : JSON.parse(sessionStorage.getItem("savedStack")) || [];
    return stack;
  }

  getSavedStack(): Array<any> {
    let stack = JSON.parse(sessionStorage.getItem("savedStack")) || []//(JSON.parse(sessionStorage.getItem("viewStack")).length > 0) ? JSON.parse(sessionStorage.getItem("viewStack")) : JSON.parse(sessionStorage.getItem("savedStack"));
    return stack;
  }

  setViewStack(stack: Array<any>): void {
    sessionStorage.setItem("viewStack", JSON.stringify(stack));
  }

  getUtlStoreServiceValues(event: Action) {
    const key = event.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'key');
    let value = event.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'value');
    return { key, value };
  }

  getUtlStoreServiceComponentValues(event: Action) {
    const key = event.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'key');
    const component = this.getComponentRef(event.actionParams[0]);
    return { key, component };
  }

  setStateToComponent(key: UtilParam, component: any) {
    this.storeService.getStateObservable(this.extractValueFromPair(key))
    .pipe(
			take(1),
			defaultIfEmpty('')
		)
    .subscribe((value: any) => {
      switch (component.getCtType()) {
        case PfComponents.CtInputText:
          component.setValue(value);
      }
    });
  }

  updateStateWithKeyValue(keyValueString, valueString) {
    const key = this.extractValueFromPair(keyValueString);
    const value = this.extractValueFromPair(valueString);
    this.storeService.setState(key, value);
  }

  extractValueFromPair(pairString) {
    return pairString.name.split('=')[1];
  }
}